import * as appHelper from './appHelper';
import { extend } from './util';
var os = appHelper.checkApp();
var useragent = window.navigator.userAgent.toLowerCase();
var commonOptions = {
    downloadUrl: 'http://app.aiyuke.com/',
    iosUrl: '',
    androidUrl: '',
    canOpenGuide: true,
    canCloseGuide: true,
    alwaysOpenDownload: false,
    closeOpenDownload: false
};
var iosSrc = 'url(//front.tiyushe.com/frontcommon_assets/images/open_app_ios.png)';
var androidSrc = 'url(//front.tiyushe.com/frontcommon_assets/images/open_app_android.png)';
var guide = document.createElement('div');
extend(guide.style, {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    zIndex: 999999,
    backgroundColor: '#f9f9f9',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    display: 'none',
    backgroundImage: os.isIOS ? iosSrc : androidSrc
});
document.body.appendChild(guide);
guide.addEventListener('click', function () {
    if (commonOptions.canCloseGuide) {
        guide.style.display = 'none';
    }
});
function getIosVersion() {
    var match = useragent.match(/os\s+(\d+)/i);
    if (match && match.length === 2) {
        return parseFloat(match[1]);
    }
    return 0;
}
function myOpenApp() {
    function _open(url) {
        // var iframe = document.createElement('iframe');
        // iframe.src = url;
        // iframe.style.display = 'none';
        // document.body.appendChild(iframe);
        var a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // a.setAttribute('onclick', 'history.back()');
        document.body.appendChild(a);
        a.click();
    }
    if (os.isIOS) {
        var iosVersion = getIosVersion();
        window.location.href = commonOptions.iosUrl;
        // if (iosVersion > 9) {
        //     window.location.href = `https://www.tiyushe.com/?rc=Redirect&app=@aykAPP_native&url=${encodeURIComponent(
        //         (<string>commonOptions.iosUrl).replace('aiyuke://', ''),
        //     )}`;
        // } else {
        //     window.location.href = <string>commonOptions.iosUrl;
        // }
    }
    else if (os.isAndroid) {
        _open(commonOptions.androidUrl);
        var startTime_1 = Date.now();
        var timer_1 = setTimeout(function () {
            if (Date.now() - startTime_1 > 1200) {
                return false;
            }
            if (window.document.webkitHidden) {
                return false;
            }
            _open('aiyuke://open_h5/#');
        }, 1000);
        document.addEventListener('webkitvisibilitychange', function () {
            clearTimeout(timer_1);
        });
        window.addEventListener('pagehide', function () {
            clearTimeout(timer_1);
        });
    }
}
function openDownload() {
    var baseTime = 0;
    if (os.isAndroid) {
        baseTime = 1000;
    }
    if (commonOptions.alwaysOpenDownload) {
        setTimeout(function () {
            window.location.href = commonOptions.downloadUrl;
        }, baseTime + 2000);
    }
    else {
        var startTime_2 = Date.now();
        var timer_2 = setTimeout(function () {
            if (Date.now() - startTime_2 > baseTime + 2200) {
                return false;
            }
            if (window.document.webkitHidden || window.document.hidden) {
                return false;
            }
            window.location.href = commonOptions.downloadUrl;
        }, baseTime + 2000);
        document.addEventListener('webkitvisibilitychange', function () {
            clearTimeout(timer_2);
        });
        window.addEventListener('pagehide', function () {
            clearTimeout(timer_2);
        });
    }
}
function openUrlInApp() {
    window.location.href = os.isIOS
        ? commonOptions.iosUrl
        : commonOptions.androidUrl;
    window.setTimeout(function () {
        appHelper.pipe('closeWindow');
    }, 2000);
}
function openGuide() {
    guide.style.display = 'block';
}
export var openApp = function (options) {
    extend(commonOptions, options);
    if (commonOptions.iosUrl === '') {
        commonOptions.iosUrl = "aiyuke://" + window.location.href;
    }
    if (commonOptions.androidUrl === '') {
        commonOptions.androidUrl = "aiyuke://open_h5/" + window.location.href;
    }
    if (os.isApp) {
        openUrlInApp();
    }
    else if (os.isWeChat) {
        commonOptions.canOpenGuide && openGuide();
    }
    else {
        myOpenApp();
        !commonOptions.closeOpenDownload && openDownload();
    }
};
//# sourceMappingURL=appBridge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_aiyuke-front-lib@1.1.6@aiyuke-front-lib/dist/appBridge.js
// module id = null
// module chunks = 